export default "__VITE_ASSET__DlDigEYx__"